import { Button, Modal } from "@mui/material"
import { IContador } from "../Interfaces/cadernos/caderno5/caderno5"
import CloseIcon from "@mui/icons-material/Close";
import { BarraDeFerramentas } from "../Components/barra-de-ferramentas/BarraDeFerramentas";
import { loader } from "../Func_genericas/loader";
import { CustomTextField } from "../Styles/theme/customThemeprovider";
import { useContext, useState } from "react";
import { ButtonCadernos } from "../Components/barra-de-ferramentas/ButtonCadernos";
import ConfirmDialog from "../Components/CustomDialog/customdialog";
import { del, post } from "../Services/tokenConfig";
import { AuthContext } from "../AuthContext/AuthContext";
import { func_print } from "../Func_genericas/func_print";
import { cores } from "../Func_genericas/valores_estaticos";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

interface I_aux {
    lista_contadores: IContador[] | undefined,
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_flag_criar_contador: React.Dispatch<React.SetStateAction<boolean>>,
    flag_criar_contador: boolean,
    set_lista_contadores: React.Dispatch<React.SetStateAction<IContador[] | undefined>>,
}

export const Modaladdeditcontador: React.FC<I_aux> = ({
    lista_contadores,
    flag_open_modal,
    set_flag_open_modal,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_flag_criar_contador,
    flag_criar_contador,
    set_lista_contadores,
}) => {
    const auth = useContext(AuthContext);
    const location = useLocation();


    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [contador, set_contador] = useState<IContador | undefined>();
    const [flag_editar_contador, set_flag_editar_contador] = useState<boolean>(false);
    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState<boolean>(false);


    const onInputchange_contador = (event: any) => {
        const { name, value, type, checked } = event.target;

        if (type === "checkbox") {
            set_contador((prev: any) => {
                return {
                    ...prev,
                    [name]: checked,
                };
            });
        } else {

            set_contador((old: any) => ({
                ...old,
                [name]: value,
            }));
        }


    };

    const handle_delete_contador = async () => {
        try {
            set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
            setIsLoading(true);
            let data = await del(auth.token.cookie_token, `delete_contador/${contador?.id_contador}`)
            if (data.status === 200) {

                let lista_aux: any = lista_contadores?.filter((el) =>
                    el.id_contador !== contador?.id_contador
                );
                setMessage("Eliminado com sucesso!");

                setOpenSnackSuccess(true);
                set_lista_contadores(lista_aux === undefined ? [] : lista_aux)
                set_contador(undefined)
            } else {
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {

            func_print('handle_delete_contador', error, true)
            setIsLoading(false);

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
        }
    }
    const handle_criar_contador = async () => {


        try {
            setIsLoading(true);

            let data = await post(auth.token.cookie_token, "new_contador", {
                payload: {
                    id_contador: 0,
                    nome: contador?.nome,
                    id_agri: location.state.id_agri,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: ""
                }
            })
            if (data.status === 200) {
                setMessage("Operação efetuada com sucesso!");
                setOpenSnackSuccess(true);
                set_contador(undefined)
                if (lista_contadores?.length === 0 || lista_contadores === undefined) {
                    set_lista_contadores([data.data.result])

                } else {
                    set_lista_contadores((old: any) => [...old, data.data.result])

                }

                set_flag_criar_contador(false)

            } else {
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
            setIsLoading(false);

        } catch (error) {
            func_print('handle_criar_contador', error, true)
            setIsLoading(false);

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
        }


    }

    const handle_editar_contador = async () => {
        try {
            setIsLoading(true);

            let data = await post(auth.token.cookie_token, "update_contador", {
                payload: {
                    id_contador: contador?.id_contador,
                    nome: contador?.nome,
                    id_agri: location.state.id_agri,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: ""
                }
            })


            if (data.status === 200) {
                setMessage("Operação efetuada com sucesso!");
                setOpenSnackSuccess(true);
                set_contador(undefined)
                set_flag_editar_contador(false)
                let lista_aux = lista_contadores?.map((el)=>{
                    if(el.id_contador === data.data.result.id_contador){
                        return data.data.result
                    }else{
                        return el
                    }

                })
                set_lista_contadores(lista_aux=== undefined? [data.data.result]: lista_aux)

            } else {
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print('handle_editar_contador', error, true)
            setIsLoading(false);

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
        }
    }

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundColor: 'white',
            width: '40%',
            height: '80%',
            flexDirection: 'column',
            borderRadius: 5,
        }}>
            <div style={{
                width: '100%',
                display: "flex",
                alignItems: 'flex-start',
                justifyContent: 'flex-end',
                flex: 0.1,
            }}>
                <Button
                    sx={{ color: "#AAAAAA" }}
                    size="large"
                    onClick={() => {
                        set_flag_open_modal(false)
                    }}
                >
                    <CloseIcon />
                </Button>
            </div>
            {
                isLoading === true ?
                    loader() :
                    <>
                        <div
                            style={{
                                backgroundColor: cores.cor1,
                                display: "flex",
                                alignItems: 'center',
                                justifyContent: 'center',
                                flex: 0.1,
                                fontWeight: 'bold',
                                color: 'white',
                                fontSize: 25,
                                width: '100%',
                                fontFamily: "candara"
                            }}>

                            Lista Contadores Registados

                        </div>
                        {flag_criar_contador === true ?
                            <div style={{
                                display: "flex",
                                alignItems: 'center',
                                justifyContent: "space-evenly",
                                flex: 0.1,
                                width: '90%',
                                flexDirection: 'row',
                                marginBottom: 20,
                                marginTop: 10
                            }}>

                                <div>
                                    <CustomTextField
                                        label='Nome'
                                        name="nome"
                                        value={contador?.nome === undefined ? '' : contador?.nome}
                                        onChange={onInputchange_contador}
                                    />
                                </div>
                                <div>

                                    <Button
                                        style={{
                                            backgroundColor: cores.cor1,
                                            color: 'white'
                                        }}
                                        onClick={() => { handle_criar_contador() }}
                                    >
                                        Guardar

                                    </Button>

                                </div>

                            </div> :
                            <div style={{
                                display: "flex",
                                alignItems: 'flex-end',
                                justifyContent: 'center',
                                flex: 0.1,
                                width: '90%',
                                flexDirection: 'column',
                                paddingBottom: 10,
                                paddingTop: 10
                            }}>

                                <BarraDeFerramentas
                                    mostrarBotaoNovo
                                    textoBotaoNovo="Novo Registo"
                                    aoClicarNovo={() => {
                                        set_flag_criar_contador(true)
                                        set_contador(undefined)
                                        set_flag_editar_contador(false)
                                    }} />
                            </div>
                        }
                        <div style={{
                            flex: 0.8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            width: '100%',
                            overflowY: 'scroll',
                            scrollbarWidth: 'thin',
                            height: '100%',
                            paddingBottom: 10
                        }}
                        >

                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                flexDirection: 'row',
                                width: '90%',

                            }}>

                                <div style={{
                                    flex: 0.1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    backgroundColor: cores.cor5,
                                    color: cores.cor1,
                                    fontWeight: 'bold',
                                    marginRight: 1,
                                    height: 35,

                                }}>
                                    ID
                                </div>
                                <div style={{
                                    flex: 0.3,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    backgroundColor: cores.cor5,
                                    color: cores.cor1,
                                    fontWeight: 'bold',
                                    marginLeft: 1,
                                    marginRight: 1,
                                    height: 35,

                                }}>
                                    Número
                                </div>
                                <div style={{
                                    flex: 0.35,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    backgroundColor: cores.cor5,
                                    color: cores.cor1,
                                    fontWeight: 'bold',
                                    marginLeft: 1,
                                    marginRight: 1,
                                    height: 35,

                                }}>
                                    Ultima Atualização
                                </div>
                                <div style={{
                                    flex: 0.25,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    backgroundColor: cores.cor5,
                                    color: cores.cor1,
                                    fontWeight: 'bold',
                                    marginLeft: 1,
                                    height: 35,

                                }}>
                                    Ações
                                </div>

                            </div>

                            {

                                lista_contadores?.map((el: IContador) => {
                                    return (
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            flexDirection: 'row',
                                            width: '90%',
                                            marginTop: 5,
                                            border: `1px solid ${cores.cor1}`,

                                        }}>
                                            <div style={{
                                                flex: 0.1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '100%',
                                                marginRight: 1,
                                                height: contador?.id_contador !== el.id_contador ? 35 : 75,



                                            }}>
                                                {el.id_contador}
                                            </div>
                                            <div style={{
                                                flex: 0.3,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '100%',
                                                marginLeft: 1,
                                                marginRight: 1,
                                                height: contador?.id_contador !== el.id_contador ? 35 : 75,
                                            }}>
                                                {
                                                    contador?.id_contador !== el.id_contador ? el.nome :

                                                        <CustomTextField
                                                            name="nome"
                                                            value={contador?.nome === undefined ? '' : contador?.nome}
                                                            onChange={onInputchange_contador}
                                                        />
                                                }

                                            </div>
                                            <div style={{
                                                flex: 0.35,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '100%',
                                                marginLeft: 1,
                                                marginRight: 1,
                                                height: contador?.id_contador !== el.id_contador ? 35 : 75,



                                            }}>
                                                {dayjs(el.last_update).format('DD/MM/YYYY')}
                                            </div>
                                            <div style={{
                                                flex: 0.25,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '100%',
                                                marginLeft: 1,
                                                height: contador?.id_contador !== el.id_contador ? 35 : 75,



                                            }}>
                                                {

                                                    flag_editar_contador === true ?
                                                        <ButtonCadernos
                                                            mostrarBotaoCancelar
                                                            mostrarBotaoGravar
                                                            aoClicarCancelar={() => {
                                                                set_contador(undefined)
                                                                set_flag_editar_contador(false)

                                                            }}
                                                            aoClicarGravar={() => {
                                                                handle_editar_contador()
                                                            }}
                                                        /> :
                                                        <ButtonCadernos
                                                            mostrarBotaoApagar
                                                            mostrarBotaoEditar
                                                            aoClicarApagar={() => {
                                                                set_contador(el)
                                                                set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                            }}
                                                            aoClicarEditar={() => {
                                                                set_contador(el)
                                                                set_flag_editar_contador(true)
                                                                set_flag_criar_contador(false)
                                                            }}
                                                        />
                                                }

                                            </div>

                                        </div>

                                    )

                                })

                            }


                        </div>
                    </>
            }
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                onConfirm={handle_delete_contador}
                message="Deseja eliminar o registo?"
            />
        </div>



    </Modal>)

}
